// Regras puras do "Pedido para X meses" (RN-EST-75): preço da linha e
// pré-preenchimento do formulário de PC. Separado do modal para teste e para o
// react-refresh (arquivo de componente só exporta componentes).

import type { PurchasePlanHorizonItem, PurchasePlanHorizonResponse } from '../../types/stockAnalytics';
import type { PurchaseOrderPrefill } from '../../types/purchaseOrder';

export const HORIZON_MIN_MONTHS = 1;
export const HORIZON_MAX_MONTHS = 12;

/** Preço usado no PC: do fornecedor, senão o custo do produto, senão zero. */
export const horizonUnitValue = (item: Pick<PurchasePlanHorizonItem, 'provider_price' | 'unit_cost'>): number =>
  item.provider_price && item.provider_price > 0 ? item.provider_price : item.unit_cost && item.unit_cost > 0 ? item.unit_cost : 0;

/** Monta o pré-preenchimento do formulário de PC com os itens marcados e quantidade > 0. */
export const buildPurchaseOrderPrefill = (
  preview: Pick<PurchasePlanHorizonResponse, 'provider_id' | 'provider_name' | 'months'>,
  items: PurchasePlanHorizonItem[],
  quantities: Record<number, number>,
  selected: Record<number, boolean>,
): PurchaseOrderPrefill => ({
  provider_id: preview.provider_id,
  provider_name: preview.provider_name,
  internal_notes: `Gerado do planejamento de compras — cobertura de ${preview.months} ${preview.months === 1 ? 'mês' : 'meses'}`,
  items: items
    .filter((it) => selected[it.product_id] && (quantities[it.product_id] ?? 0) > 0)
    .map((it) => ({
      product_id: it.product_id,
      sku: it.sku,
      description: it.description ?? it.sku,
      quantity: quantities[it.product_id],
      unit_value: horizonUnitValue(it),
    })),
});
